import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeReceiptCreateScreen from '../screens/BackOfficeReceiptCreateScreen'

const mapStateToProps = (state) => {
    return {
        state: state.users
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

class BackOfficeReceiptCreateContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading : false,
            error: null,
            receiptCreateSuccess: false
        }
    }

    onSubmit(data) {
        this.setState({loading: true, error: null, receiptCreateSuccess: false});
        let receipt = data;
        receipt.method = "SPORTELLO";
        SostaOnlineApiService.createReceipt(receipt).then(result => {
            this.setState({error: null, loading: false, receiptCreateSuccess: true});
        }).catch(err => {
            this.setState({error: "Errore nella creazione della Ricevuta", loading: false, receiptCreateSuccess: false});
        });
    }

    render() {
        return(
            <BackOfficeReceiptCreateScreen
                loading={this.state.loading}
                receiptCreateError={this.state.error}
                receiptCreateSuccess={this.state.receiptCreateSuccess}
                onSubmit={this.onSubmit.bind(this)}/>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeReceiptCreateContainer);


// WEBPACK FOOTER //
// ./src/containers/BackOfficeReceiptCreateContainer.js